import { urlService } from "./urlService";

export const getSelectedDataDetails = ({dataList, searchId}) => {
  const selectedId = +urlService.getQueryStringValue(searchId);
  return dataList.filter((item) => item.id === selectedId);
};
